exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-purple[data-v-2cde2397] {\n  color: #fff;\n  background: #5c4ac7;\n  border: 1px solid #5c4ac7;\n}\n.btn-purple[data-v-2cde2397]:active {\n  background-color: #5c4ac7;\n  border: 1px solid #5c4ac7;\n}\n.address-link[data-v-2cde2397], address-link[data-v-2cde2397]:hover {\n  color: #455a64;\n  text-decoration: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2cde2397","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/address/AddressList.vue
// module id = Qe9w
// module chunks = 1